import { VersionsStateShape } from 'store';

export default {
	current: null,
	versions: Object(null)
} as VersionsStateShape;
